export enum EPackageCoverageGroup {
  CruiseAndLand = 'CruiseAndLand',
  Cruise = 'Cruise',
  Other = 'Other',
}
